'use client';

import { Tabs as MuiTabs, styled, type TabsProps } from '@mui/material';
import type { ReactNode } from 'react';

interface Props extends TabsProps {
  value: string | null;
}

const Tabs = styled((props: Props) => <MuiTabs {...props} />, {
  name: 'RmtTabs',
})({
  overflow: 'visible',
  backgroundColor: 'transparent',
  '& .MuiTabs-scroller': {
    overflow: 'visible',
  },
  // v9 renamed the Tabs flex container slot: `.MuiTabs-flexContainer` no longer
  // exists (tabsClasses went from `root vertical flexContainer flexContainerVertical
  // list ...` in v7 to `root vertical list ...` in v9), so this rule silently
  // stopped matching and the tabs lost their 8px gap. `.MuiTabs-list` is the same
  // element — the slot that carries `display: flex`.
  '& .MuiTabs-list': {
    gap: 8,
  },
  '& .MuiTabs-indicator': {
    backgroundColor: 'transparent',
  },
});

export default Tabs;
